export default __webpack_public_path__ + "static/media/Act5_Vastaaja.56d72744.svg";